var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{staticClass:"banner__img",attrs:{"src":_vm.competition.bannerImgUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }